// Builds the grouped menu data ({ key, items }) for the DevExtreme List.
// An item's `matchPaths` are the route prefixes that mark it as the current page.
export function buildMenuGroups(memberId, managedSchools, committees) {
  const groups = [{
    key: 'Member',
    items: [
      { path: '/', text: 'Home', icon: 'fa-solid fa-house', matchPaths: ['/'] },
      {
        path: `/edit-profile/${memberId}`,
        text: 'My Profile',
        icon: 'fa-solid fa-user',
        matchPaths: ['/edit-profile'],
      },
    ],
  }];

  // managedSchools has one row per CSR role, so a school can appear more than once.
  const schoolIds = [...new Set((managedSchools || []).map(s => s.schoolId))];
  if (schoolIds.length > 0) {
    groups.push({
      key: 'Staff Lists',
      items: schoolIds.map((schoolId) => ({
        path: `/school/${schoolId}`,
        text: managedSchools.find(s => s.schoolId === schoolId).name,
        icon: 'fa-solid fa-building',
        matchPaths: [`/school/${schoolId}`],
      })),
    });
  }

  if (committees && committees.length > 0) {
    groups.push({
      key: 'Committees',
      items: committees.map((c) => ({
        path: `/committee-documents-grid/${c.committeeId}`,
        text: c.committeeName,
        icon: 'fa-solid fa-folder',
        matchPaths: [
          `/committee-documents-grid/${c.committeeId}`,
          `/committee-documents/${c.committeeId}`,
        ],
      })),
    });
  }

  return groups;
}

// Returns the path of the menu item whose matchPaths best (longest) match the
// current location, so nested routes such as /school/5/123 highlight /school/5.
export function findSelectedPath(groups, pathname) {
  let selected = null;
  let bestLength = -1;
  groups.forEach(group => group.items.forEach((item) => {
    item.matchPaths.forEach((matchPath) => {
      const matches = matchPath === '/'
        ? pathname === '/'
        : pathname === matchPath || pathname.startsWith(`${matchPath}/`);
      if (matches && matchPath.length > bestLength) {
        selected = item.path;
        bestLength = matchPath.length;
      }
    });
  }));
  return selected;
}
